module.exports = __webpack_public_path__ + "static/img/rank_236.862f975.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_236.png
// module id = dSlj
// module chunks = 1